/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

const CategoriesTable = ({ categories, companyURL, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (categories.loading) {
      return "is Loading";
    }
    if (isEmpty(categories.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Tag Count</th>
            <th>Freezed</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {categories.data.map(category => (
            <tr key={category.id}>
              <td>{category.id}</td>
              <td>{category.name}</td>
              <td>{category.tags ? category.tags.length : 0}</td>
              <td>{category.freezed === 1 ? "Yes" : "No"}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/${companyURL}/categories/${category.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Update</span>
                  </Link>
                  <a
                    onClick={onClickDelete(category.id)}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};
export default CategoriesTable;
